
import { FormGroup, ValidationErrors, ValidatorFn, Validators, FormControl } from "@angular/forms";
import { PaymentMethod } from "../enums/paymentMethod.enum";

/*
 If the payment method is Direct Deposit (2)
		¬ Bank Account: Is required
		¬ Bank Address 1: Is required.
		¬ Bank City: Is required.
		¬ Bank Name: Is required.
		¬ Bank Country: Is required
		¬ Bank Account: Is required.
 */
   
export function paymentMethodCrossValidator(controlName: string, validatorKey: string) : ValidatorFn {

  return (formGroup: FormGroup): ValidationErrors | null => {
    let result: ValidationErrors = null;
   
    if(formGroup.get('payMethod').value === PaymentMethod.DIRECT_DEPOSIT){  
      if (!formGroup.get(controlName).value) {
        result = {};
        result[validatorKey] = 'fieldValidation.required'
      }
    }
    return result;
  };
}
